/* Custom form elements */
/* Created by Vladimir Khodakov (web-interface.info team) */
/* Modified by Grigory Zarubin (https://github.com/Craigy-) */

(function ($) {
  $.fn.inputs = function (options) {
    var opts = $.extend({}, $.fn.inputs.defaults, options);

    return this.each(function () {
      var el = $(this);
      el.type = el.attr('type');
      // Атрибут data-as для изменения представления элемента (например чекбокс в виде радиокнопки)
      el.typeClass = el.data('as') ?? el.type;
      if (el.is('input') && opts[el.type] && !el.next().hasClass(el.typeClass)) {
        var tname = el.attr('name');
        var tid = el.attr('id');
        el.name = (tname !== undefined && tname != '') ? tname.replace(/[\[\]]/g, '') : ((tid !== undefined && tid != '') ? tid.replace(/[\[\]]/g, '') : (Math.round(Math.random() * 10000) + 1));
        el.replace = (el.type != 'file') ? '<span class="' + el.typeClass + ' el-name-' + el.name + '"></span>' : '<span class="' + el.typeClass + '"><span class="button">' + (el.data('title') || opts.fileTitle) + '</span></span><span class="file-value"></span>';
        el.handle = el.after(el.replace);
        el.hide();
        switch (el.type) {
          case 'checkbox':
            if (el.prop('checked')) {
              el.next().addClass(el.typeClass + '-checked');
            }
            if (el.prop('disabled')) {
              el.next().addClass(el.typeClass + '-disabled');
            }
            el.next().on('click', function (e) {
              if (!el.prop('disabled')) {
                e.preventDefault();
                e.stopPropagation();
                $(this).toggleClass(el.typeClass + '-checked');
                if (!el.prop('checked')) {
                  el.prop('checked', true).trigger('change');
                } else {
                  el.prop('checked', false).trigger('change');
                }
              }
            });
            el.on('click', function () {
              if (!el.prop('disabled')) {
                el.next().toggleClass(el.typeClass + '-checked');
              }
            });
            $('label[for="' + tid + '"]').on('click', function (e) {
              if (!el.prop('disabled')) {
                e.preventDefault();
                var inp = $('#' + $(this).attr('for'));
                inp.next().toggleClass(el.typeClass + '-checked');
                if (!inp.prop('checked')) {
                  inp.prop('checked', true).trigger('change');
                } else {
                  inp.prop('checked', false).trigger('change');
                }
              }
            });
            break;
          case 'radio':
            if (el.prop('checked')) {
              el.next().addClass(el.typeClass + '-checked');
            }
            if (el.prop('disabled')) {
              el.next().addClass(el.typeClass + '-disabled');
            }
            el.next().on('click', function () {
              if (!el.prop('checked') && !el.prop('disabled')) {
                $('.el-name-' + el.name).removeClass(el.typeClass + '-checked');
                el.prop('checked', true).trigger('change');
                $(this).addClass(el.typeClass + '-checked');
              }
            });
            el.on('click', function () {
              if (!el.prop('disabled')) {
                $('.el-name-' + el.name).removeClass(el.typeClass + '-checked');
                el.prop('checked', true).trigger('change');
                el.next().addClass(el.typeClass + '-checked');
              }
            });
            break;
          case 'file':
            el.id = el.attr('id');
            el.show();
            el.emulate = el.next();
            el.emulate.append(el);
            el.emulate.find('input').on('change', function () {
              el.emulate.next('.file-value').html($(this).val());
            });
            break;
        }
      }
    });
  };

  $.fn.inputs.defaults = {
    checkbox   : true,
    radio      : true,
    file       : true,
    fileTitle  : 'Обзор'
  };
})(jQuery);